export default {
  id: 0,
  policy_number: '',
  houseDetails: {
    house_use: null,
    roof_type: null,
    province: '',
    city: '',
    address: ''
  },
  first_name: '',
  last_name: '',
  email_address: '',
  estimated_value: '',
  start_date: '',
  end_date: '',
  period_of_cover: '',
  premium: '0.00',
  currency: null,
  base: '0.00',
  levy: '0.00',
  rate: '0',
  discount: '0.00'
}